import { InertiaLink, usePage } from "@inertiajs/inertia-react";
import { Trans } from "../utils/i18n";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

export function VatNumberBox({ vatNumber }) {
    const { user } = usePage().props;

    const renderedVatNumber = vatNumber ?? user?.company?.vat_number;

    if (!user?.company) return null;

    return (
        <div className="bg-white flex w-full gap-3 items-center flex-wrap rounded-lg p-6 b2x-shadow-md">
            <div className="flex items-center gap-2">
                <span className="font-bold">
                    <Trans i18nKey="auth.register.vat_number">VAT number</Trans>
                </span>
                <span>{renderedVatNumber}</span>
                <a href={route('profile')} target="_blank">
                  <EditOutlinedIcon color="primary" />
                </a>
            </div>
        </div>
    );
}
